module.exports = __webpack_public_path__ + "media/components/Insulation/QuietZoneCalculator/icons/moose-4ec499866b08ae3c3e9e43b0c60377e0.svg";